import {Pipe, PipeTransform} from "@angular/core";
import {Order} from "../../store/state/order.state";
import {TranslateService} from "@ngx-translate/core";
import {Observable, of} from "rxjs";
import {map} from "rxjs/operators";

@Pipe({
    name: 'selectedProducts',
    standalone: false
})
export class SelectedProductsDisplayPipe implements PipeTransform {

	constructor(private translateService: TranslateService) {
	}

	transform(order: Order, separator?: Separator): Observable<string> {
		return (['and', ',+and'].includes(separator) ? this.translateService.get('common.separator') : of(separator)).pipe(map(separatorToUse => {
			return this.getSelectedProducts(order, separatorToUse, separator == ',+and');
		}));
	}

	private getSelectedProducts(order: Order, separator?: Separator, combined?: boolean) {
		return order.products.map(product => product.standard.name.replace('_', ' ')).reduce((s1, s2, index) => {
			if (combined) {
				const isLast = index == order.products.length - 1;
				const currentSeparator = isLast ? separator : ',';
				return (index == 0 ? s2 : s1 + SelectedProductsDisplayPipe.getSeparator(currentSeparator) + s2);
			}
			return (index == 0 ? s2 : s1 + SelectedProductsDisplayPipe.getSeparator(separator) + s2);
		}, '');
	}

	private static getSeparator(separator: Separator) {
		return (separator == "," ? '' : ' ') + (!!separator ? separator : "&") + ' ';
	}
}

export type Separator = 'and' | '&' | ',' | ',+and';
